import { gql } from '@apollo/client'
import { pathOr } from 'ramda'
import React from 'react'

import { usePromiseQuery } from '../../../utils/apollo/_helpers/promiseQuery'
import Select from '../../../packages/kiti/components/form/Select'
import { integrationsClient } from '../../../utils/apollo/api'
import { groupCategories } from './_helpers/helpers'

const QUERY = gql`
  query omieDepartaments($integrationId: Int, $page: Int) {
    omieDepartaments(integrationId: $integrationId, page: $page, limit: 30) {
      descricao
      estrutura
      inativo
      codigo
    }
  }
`

export const useDepartamentsSelectLoader = filter => {
  const query = usePromiseQuery(QUERY, { client: integrationsClient })

  return (search, page = 1) => {
    return query({ search, page, ...filter })
      ?.then(pathOr([], ['data', 'omieDepartaments']))
      .then(data => {
        const result = data.map((item, index) => {
          return {
            id: index,
            codigo: item.codigo,
            name: item.descricao,
            estrutura: item.estrutura,
            inativo: item.inativo
          }
        })

        return result
      })
  }
}

const DepartamentsSelect = ({ onChange, value, filter, ...props }) => {
  const getOptions = useDepartamentsSelectLoader(filter)

  return <Select value={value} onChange={onChange} options={getOptions} {...props} />
}

export default DepartamentsSelect
